import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BookingPage from './pages/BookingPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ExpiredPage from './pages/ExpiredPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import BarbersManager from './pages/BarbersManager';
import OwnerAdminPage from './pages/OwnerAdminPage';
import LegalPage from './pages/LegalPage';
import SaasCheckoutPage from './pages/SaasCheckoutPage';
import AppointmentManagePage from './pages/AppointmentManagePage';
import CookieNotice from './components/CookieNotice';
import { ToastProvider } from './components/ToastProvider';
import { TutorialProvider } from './tutorial/TutorialProvider';

function App() {
  return (
    <ToastProvider>
      <TutorialProvider>
      <div className="min-h-screen bg-dark-900">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/barbearia/:id" element={<BookingPage />} />
          <Route path="/b/:slug" element={<BookingPage />} />
          <Route path="/payment-success/:id" element={<PaymentSuccessPage />} />
          <Route path="/appointment/:id/manage" element={<AppointmentManagePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard/:id/*" element={<Dashboard />} />
          <Route path="/barbers" element={<BarbersManager />} />
          <Route path="/admin-dono" element={<OwnerAdminPage />} />
          <Route path="/checkout/:plan" element={<SaasCheckoutPage mode="new" />} />
          <Route path="/checkout/renew/:barbershopId/:plan" element={<SaasCheckoutPage mode="renewal" />} />
          <Route path="/expired" element={<ExpiredPage />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/politica-de-privacidade" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/termos-de-uso" element={<LegalPage type="terms" />} />
        </Routes>
        <CookieNotice />
      </div>
      </TutorialProvider>
    </ToastProvider>
  );
}

export default App;
